<template>
  <div>
    <div style="position: relative; width: 1024px; display: inline-block;">

      <svg xmlns="http://www.w3.org/2000/svg" width="796" height="316" viewBox="0 0 796 316">
        <g fill="none" fill-rule="evenodd">
          <slot name="g"/>
        </g>
      </svg>

      <slot/>
    </div>
  </div>
</template>

<script>

export default {}
</script>

<style scoped>

</style>
